// Shared option sets + labels for the manual task-creation form — one source
// so its two entry forms stay in sync.

export const PRIORITIES = ['urgent', 'high', 'normal', 'low'];

export const PRIORITY_LABELS = {
  urgent: 'Urgent', high: 'High', normal: 'Normal', low: 'Low',
};

export const TASK_TYPES = ['action', 'review', 'reminder', 'submission', 'notification'];

export const CLINICAL_DOMAINS = ['bp', 'weight', 'lab', 'medication', 'reporting', 'compliance', 'outreach', 'device'];

export const ASSIGNABLE_ROLES = ['care_coordinator', 'clinician'];

export const OWNER_ROLE_LABELS = {
  care_coordinator: 'Care Coordinator',
  clinician: 'Clinician',
  // Legacy aliases — kept so historical task rows still render a label until backfilled.
  md: 'Clinician', rn: 'Clinician', np: 'Clinician', pharmacist: 'Clinician', care_team: 'Clinician',
  operations: 'Care Coordinator', admin: 'Care Coordinator', ops: 'Care Coordinator', operator: 'Care Coordinator',
};

// Template_code backing ad-hoc staff tasks created from the UI (seed: cc_custom_task).
export const CUSTOM_TASK_TEMPLATE_CODE = 'cc_custom_task';

// Stable idempotency key for one create-task surface instance — minted once on
// open and reused on a double-submit so apiv2's dedupe_key ON CONFLICT yields one task.
export function mintManualDedupeKey() {
  return (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? `manual:${crypto.randomUUID()}`
    : `manual:${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

// The due-date picker is a `type="date"` field → 'YYYY-MM-DD' (or ''). Anchor at
// end-of-day LOCAL so the task isn't overdue mid-day and the creator's chosen date
// never displays a day early in their own timezone. Returns an ISO string, or null.
export function dueDateToIso(dateStr) {
  return dateStr ? new Date(`${dateStr}T23:59:00`).toISOString() : null;
}
